import { render, staticRenderFns } from "./JobActivityHistory.vue?vue&type=template&id=248e3461&scoped=true"
import script from "./JobActivityHistory.vue?vue&type=script&lang=js"
export * from "./JobActivityHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e3461",
  null
  
)

export default component.exports